import { counted } from '../plural';
import type { Messages } from '../shape';

export const errors = {
  byReason: {
    route_not_found: 'На сервере нет такого адреса.',
    method_not_allowed: 'Этот адрес не принимает такие запросы.',
    body_too_large: 'Это больше, чем сервер принимает за один запрос.',
    query_invalid: 'Сервер не смог разобрать один из параметров запроса.',
    if_match_required: 'Запись не указала, на какой версии она основана.',
    if_match_invalid: 'Версия, названная в записи, сервером не читается.',
    rate_limited: 'Слишком много запросов подряд. Сервер снова примет их через несколько минут.',
    internal:
      'На сервере сбой, и дело не в том, что вы отправили. Попробуйте ещё раз через минуту.',
    database_unavailable:
      'Сервер сейчас не достучится до своей базы данных. Ничего не потеряно, попробуйте ещё раз через минуту.',

    auth_header_missing: 'Запрос ушёл без токена входа. Войдите заново.',
    token_invalid: 'Этот вход больше не действует. Войдите заново.',
    unauthenticated: 'Вы не вошли. Войдите заново.',

    login_blank: 'Логин не может быть пустым.',
    login_taken: 'Этот адрес уже зарегистрирован.',
    invalid_credentials: 'Неверный логин или парольная фраза.',
    password_invalid: 'Эта парольная фраза не подходит к аккаунту.',
    display_name_blank: 'Отображаемое имя не может быть пустым.',
    refresh_token_invalid: 'Срок сессии истёк. Войдите заново.',
    refresh_token_reused:
      'Токен входа предъявили дважды — так ведёт себя украденный. Все сессии этого аккаунта отозваны. Войдите заново.',
    recovery_code_invalid: 'Неверный логин или код восстановления.',
    recovery_token_invalid:
      'Это восстановление больше не действует. Начните заново — с логина и кода восстановления.',
    session_id_invalid: 'Сервер не понял, о какой сессии речь.',
    session_not_found: 'Это устройство уже вышло из аккаунта.',

    not_found:
      'Этого больше нет: либо оно удалено, либо код или ссылка, которые на него указывали, уже не действуют.',
    forbidden: 'Вашего доступа здесь для этого не хватает.',
    version_conflict:
      'Кто-то сохранил эту заметку раньше вас. Обновите страницу, чтобы увидеть их версию.',
    scope_mismatch:
      'Это запечатано не тем ключом, который нужен на новом месте. Обновите страницу — ключи могли смениться с тех пор, как вкладка их прочитала.',
    folder_cycle: 'Папку нельзя переместить внутрь самой себя.',
    depth_exceeded: 'Глубже вкладывать папки нельзя.',
    share_expiry: 'Срок публичной ссылки должен приходиться на будущее.',
    link_batch: 'Заметка может ссылаться не более чем на 500 других.',
    signature_invalid: 'Подпись этой записи не принята.',
    rekey_stale: 'Эта ротация ключа больше не открыта. Запустите её заново.',
    key_grant_missing:
      'Новый ключ нужно запечатать хотя бы одному участнику, иначе его никто не откроет.',
    rekey_batch: 'Ротация отправляет от 1 до 200 строк за раз.',
    epoch_mismatch:
      'Эту сессию редактирования сменила более новая. Обновите страницу, чтобы присоединиться к ней.',
    compact_required:
      'Сессию редактирования нужно сохранить, прежде чем она примет новые изменения.',
    update_too_large:
      'Сессия редактирования выросла больше, чем сервер готов держать. Обновите страницу, чтобы начать новую.',
    label_incomplete: 'Имя должно прийти целиком: и шифротекст, и одноразовое число к нему.',

    owner_required:
      'Это может только владелец хранилища, а самого владельца из хранилища убрать нельзя.',
    self_target: 'К себе это применить нельзя.',
    already_member: 'Вы уже участник этого хранилища.',
    keys_required:
      'Для этого изменения ключи хранилища должны быть запечатаны участнику, а они не пришли.',
    group_members: 'В группе должно быть от 1 до 200 участников.',
    group_keyless: 'Менять состав группы может только тот, кто в ней состоит.',
    group_scopes: 'Ротация группы должна заново запечатать все области ключей, которые она держит.',
    group_rotation:
      'Чтобы убрать участника из группы, нужен новый ключ группы и заново запечатанные области ключей.',
    invite_path: 'Приглашение указывает либо код, либо человека, но не то и другое сразу.',
    redeem_path:
      'Приглашение погашается либо кодом, либо идентификатором, но не тем и другим сразу.',

    connector_role_invalid: 'Коннектор может быть Редактором или Читателем, и никем больше.',
    connector_exists: 'У этого хранилища уже есть коннектор.',

    // Not from the server: these are the faults `lib/archive.ts` and `lib/zip.ts` name when
    // a file dropped on the import modal turns out not to be an archive. They share the
    // table because they answer the same question — why did that not work — and because the
    // two vocabularies cannot collide: the server writes snake_case, these are kebab-case.
    'no-manifest': 'Это не архив Shelf: в нём нет описи.',
    'unreadable': 'Опись этого архива не читается.',
    'not-shelf': 'Это не архив Shelf.',
    'too-new': 'Архив записан более новой версией Shelf. Обновитесь и попробуйте импортировать снова.',
    'incomplete': 'Опись этого архива неполная, поэтому непонятно, что в нём лежит.',
    'not-a-zip': 'Это не zip-архив.',
    'zip64': 'Архив в формате Zip64 — Shelf такие не читает.',
    'directory-damaged': 'Оглавление архива повреждено.',
    'entry-misplaced': 'Файл внутри архива лежит не там, где указано в оглавлении.',
    'entry-truncated': 'Файл внутри архива обрывается на середине.',
    'method-unsupported': 'Файл внутри архива упакован способом, который Shelf не читает.',
    'entry-corrupt': 'Файл внутри архива не пережил дорогу: контрольная сумма не сходится.',
  } as Record<string, string>,

  byCode: {
    bad_request: 'Сервер не понял запрос.',
    validation_error: 'Сервер отклонил запрос как некорректный.',
    unauthorized: 'Вы не вошли. Войдите заново.',
    forbidden: 'У вас нет прав на это действие.',
    not_found: 'Этого больше нет.',
    conflict: 'Кто-то изменил это раньше вас.',
    payload_too_large: 'Слишком большой объём для отправки.',
    too_many_requests: 'Слишком много попыток. Попробуйте через минуту.',
    internal_error: 'На сервере что-то пошло не так.',
  } as Record<string, string>,

  byStatus: {
    400: 'Сервер отклонил запрос.',
    401: 'Вы не вошли. Войдите заново.',
    403: 'У вас нет прав на это действие.',
    404: 'Этого больше нет.',
    409: 'Кто-то изменил это раньше вас.',
    413: 'Слишком большой объём для отправки.',
    429: 'Слишком много попыток. Попробуйте через минуту.',
  } as Record<number, string>,

  retryIn: (minutes: number) =>
    `Слишком много попыток. Попробуйте через ${counted(minutes, ['минуту', 'минуты', 'минут'])}.`,

  offline: 'Нет связи с сервером.',
  badPassphrase: 'Ключи не открылись этой парольной фразой.',
  unknown: 'Что-то пошло не так.',
} satisfies Messages['errors'];
